module.exports = __webpack_public_path__ + "static/media/rikTorfs.256ff21d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/rikTorfs.jpg
// module id = 1689
// module chunks = 1